import React, {useContext} from 'react';
import Breadcrumb from '@article-overview/components/header/Breadcrumb.jsx';
import FilterOrderingButton from '@article-overview/components/header/FilterOrderingButton.jsx';
import FilterContainer from '@article-overview/components/header/FilterContainer.jsx';
import FilterTokens from '@article-overview/components/header/FilterTokens.jsx';
import {useBreakpointUp} from 'bonprix-design-system';
import {useStickyOffset} from '@article-overview/components/hooks/use-sticky-offset.js';
import {articleOverviewStaticContext} from '@article-overview/components/ArticleOverviewStatic.jsx';

export default function OverviewHeader({
    shouldRenderBreadcrumbs,
    breadcrumbs,
    landmarkContent,
    filterContent,
    ordering,
    filledArticleList,
    noArticlesError,
}) {
    const {filterRootShopId} = useContext(articleOverviewStaticContext);
    const breakpointLUp = useBreakpointUp('l');
    const {stickyElementRef, offsetTop} = useStickyOffset();

    const rootShopName = breadcrumbs?.items.find((item) => item.shopId === filterRootShopId.current)?.name;

    return (
        <>
            <div className="article-overview__header" ref={stickyElementRef}>
                {shouldRenderBreadcrumbs && <Breadcrumb breadcrumbs={breadcrumbs} />}
                {breakpointLUp && (
                    <div className="article-overview__header-filter-btn">
                        <FilterOrderingButton filterViewValue={landmarkContent?.filterViewLandmark} />
                    </div>
                )}
            </div>
            <FilterContainer
                filterContent={filterContent}
                landmarkContent={landmarkContent}
                ordering={ordering}
                filledArticleList={filledArticleList}
                showOnlyTokens={!filledArticleList && !noArticlesError}
                rootShopName={rootShopName}
                subshopsTopOffset={offsetTop}
            />
            <FilterTokens
                filterTokens={filterContent.filterTokens}
                shopIdFilterGroup={filterContent.shopIdFilterGroup}
            />
        </>
    );
}
